<template>
  <div class="border-t border-gray-100 pb-safe bg-white md:hidden">
    <div class="px-2 pt-2 pb-1 flex gap-3 items-center w-full z-[990]">
      <MenuItem
        v-for="item in items"
        :key="item.id"
        :title="item.title"
        :icon="icons[item.id].icon"
        :active-icon="icons[item.id].activeIcon"
        :to="item.to"
        :unread-hints="item.unreadHints"
        :width="100/items.length"
      />
    </div>
  </div>
</template>

<script setup lang="ts">

import MenuItem from '@/application/menu/components/MenuItem.vue';
import { Finanzmanager } from '@/application/router/types/types';
import { useMenuItems } from '@/application/menu/composables/menuItems';

const { items } = useMenuItems();

const icons = {
  [Finanzmanager.CHECKUP]: {
    icon: ['fat', 'ballot-check'],
    activeIcon: ['fas', 'ballot-check'],
  },
  [Finanzmanager.BEDARF]: {
    icon: ['fat', 'list-check'],
    activeIcon: ['fas', 'list-check'],
  },
  [Finanzmanager.VERTRAEGE]: {
    icon: ['fat', 'handshake'],
    activeIcon: ['fas', 'handshake'],
  },
  [Finanzmanager.DOKUMENTE]: {
    icon: ['fat', 'file-lines'],
    activeIcon: ['fas', 'file-lines'],
  },
  [Finanzmanager.BANKING]: {
    icon: ['fat', 'building-columns'],
    activeIcon: ['fas', 'building-columns'],
  },
}
</script>
